<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Language</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Index`]="{ item }">
        {{
          list
            .map(function (x) {
              return x.langid;
            })
            .indexOf(item.langid) + 1
        }}
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "language",
        disabled: true,
      },
    ],
    list: [],
    headers: [
      { text: "#", value: "langid" },
      { text: "Name", value: "langname" },
      { text: "Code", value: "langcode" },
    ],
  }),
  mounted() {
    this.getAllLang();
  },
  components: {
    Breadcrumbs,
  },
  methods: {
    getAllLang() {
      this.$store
        .dispatch("GetFromAPI", "/admin/lang")
        .then((response) => {
          this.list = response["data"]["data"];
        });
    },
  },
};
</script>